import axios from 'axios';
import { APIResponse, CreateDonationPageRequest, CreateDonationRequest, Donation, DonationPage } from '../types';

const API_BASE_URL = 'https://backend.streamlab.fun/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiService = {
  // Health check
  healthCheck: async (): Promise<APIResponse> => {
    const response = await api.get('/health');
    return response.data;
  },

  // Donation pages
  createDonationPage: async (data: CreateDonationPageRequest): Promise<APIResponse> => {
    const response = await api.post('/pages', data);
    return response.data;
  },

  getDonationPage: async (id: string): Promise<APIResponse<DonationPage>> => {
    const response = await api.get(`/pages/${id}`);
    return response.data;
  },

  updateDonationPage: async (id: string, data: { min_amount: number; description: string }): Promise<APIResponse<DonationPage>> => {
    const response = await api.put(`/pages/${id}`, data);
    return response.data;
  },

  getDonationPagesByWallet: async (publicKey: string): Promise<APIResponse<DonationPage[]>> => {
    const response = await api.get(`/wallet/${publicKey}/pages`);
    return response.data;
  },

  // Donations (теперь с tx_hash и status)
  createDonation: async (pageId: string, data: CreateDonationRequest): Promise<APIResponse> => {
    const response = await api.post(`/pages/${pageId}/donations`, data);
    return response.data;
  },

  getDonations: async (pageId: string): Promise<APIResponse<Donation[]>> => {
    const response = await api.get(`/pages/${pageId}/donations`);
    return response.data;
  },
};

export default apiService;